import React from 'react';
import { Star, MessageCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const ClientReviews = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Client Reviews - Coming Soon</CardTitle>
        </CardHeader>
        <CardContent className="p-8 text-center">
          <Star className="w-16 h-16 text-gray-400 mx-auto mb-4" />
          <h3 className="font-semibold text-lg mb-2">Review Management System</h3>
          <p className="text-gray-600">
            Collect, manage, and showcase client testimonials and reviews.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClientReviews;